import { supabase } from "@/integrations/supabase/client";
import { Json } from "@/integrations/supabase/types";

export type CoachEventName =
  | "coach_behavioral_observation_viewed"
  | "coach_veera_opened"
  | "coach_veera_prompt_selected"
  | "coach_veera_question_submitted"
  | "coach_veera_evidence_opened";

interface TrackCoachEventParams {
  coachId: string;
  leaderId?: string | null;
  eventName: CoachEventName;
  properties?: Json;
  eventId?: string;
}

export async function trackCoachEvent({
  coachId,
  leaderId = null,
  eventName,
  properties = {},
  eventId,
}: TrackCoachEventParams): Promise<void> {
  try {
    const row = {
      ...(eventId ? { id: eventId } : {}),
      coach_id: coachId,
      leader_id: leaderId,
      event_name: eventName,
      event_properties: properties,
    };
    const { error } = eventId
      ? await supabase.from("coach_event_logs").upsert([row], {
        onConflict: "id",
        ignoreDuplicates: true,
      })
      : await supabase.from("coach_event_logs").insert([row]);

    if (error) {
      console.error("Failed to track coach event:", error);
    }
  } catch (error) {
    console.error("Failed to track coach event:", error);
  }
}
